import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';

const RedditReportStatCellRenderer: FC<ICellRendererParams & { addCurrency?: boolean, divisor?: number, isRate?: boolean }> = (params) => (
	<div className="px-[8px] flex justify-between">
		<div className="text-[10px] text-gray-700 font-medium">
			{params.addCurrency ? params.data?.currency ?? '' : ''}
			{params.isRate ? '%' : ''}
		</div>
		<div>
			{
				(params.isRate
					? Number(params.value) * 100
					: Number(params.value / (params.divisor ?? 1))
				).toLocaleString(
					[],
					{ maximumFractionDigits: 2, minimumFractionDigits: params.addCurrency ? 2 : 0 },
				)
			}
		</div>
	</div>
);

export default RedditReportStatCellRenderer;
